import React, {memo, useState} from 'react';
import {useLocalizer} from '@/common/services/localizer';
import {SettingsMenu} from '../SettingsMenu';
import styles from './SettingsButton.css';

export const SettingsButton = memo(() => {
	const [menuShown, setMenuShown] = useState(false);
	const t = useLocalizer();

	const toggleMenuShown = () => {
		setMenuShown(!menuShown);
	};

	return (
		<div className={styles.root}>
			<button className={styles.button} type='button' onClick={toggleMenuShown}>
				{t('settings.title')}
			</button>
			{menuShown && <SettingsMenu onClose={toggleMenuShown} />}
		</div>
	);
});

SettingsButton.displayName = 'SettingsButton';
